module.exports = __webpack_public_path__ + "static/img/ita.0f7679c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ita.jpg
// module id = AOxF
// module chunks = 15